export const getIpAndCountry = async () => {
  try {
    const res = await fetch("https://ipapi.co/json/");
    if (!res.ok) throw new Error("Network response was not ok");

    const data = await res.json();

    return {
      ip: data.ip,
      country: data.country_name,
      countryCode: data.country_code,
    };
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Error fetching IP/location:", error);
    return null;
  }
};
